import DiagnosticFields, { Signature as DiagnosticFieldsSignature } from '../breast-cancer/diagnostic-fields';
import templateOnly, { TOC } from '@ember/component/template-only';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const MedicalHistoryFormBreastTNM0CancerDiagnosticFieldsComponent = setComponentTemplate(precompileTemplate("\n    <DiagnosticFields @form={{@form}} @patient={{@patient}} />\n  ", {
  strictMode: true,
  scope: () => ({
    DiagnosticFields
  })
}), templateOnly(undefined, "diagnostic-fields:MedicalHistoryFormBreastTNM0CancerDiagnosticFieldsComponent"));
export default MedicalHistoryFormBreastTNM0CancerDiagnosticFieldsComponent;